<template>
    <div class="main">
        <c-panel title="IMPORTAR TABELAS AUXILIARES DO EDUCACENSO" titleIcon="fas fa-file-import">
            <el-alert type="info" :closable="false" show-icon class="u-mb-15"
                title="Envie uma planilha (CSV ou Excel .xlsx). A 1ª linha deve conter os nomes das colunas exatamente como listado abaixo. Cada linha é inserida ou atualizada (upsert) pela coluna-chave.">
            </el-alert>

            <el-form label-position="top">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Tabela auxiliar">
                            <el-select v-model="tabela" filterable placeholder="Selecione a tabela" style="width:100%;" @change="onTabela">
                                <el-option v-for="t in tabelas" :key="t.tabela" :label="t.label" :value="t.tabela"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" v-if="tabelaSel">
                        <el-form-item label="Coluna-chave (usada para atualizar registros existentes)">
                            <el-input :value="tabelaSel.chave" readonly></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-form-item v-if="tabelaSel" label="Colunas esperadas no cabeçalho da planilha">
                    <div>
                        <el-tag v-for="c in tabelaSel.colunas" :key="c" size="small" class="u-mr-5" style="margin-bottom:5px;">{{ c }}</el-tag>
                    </div>
                </el-form-item>

                <el-form-item label="Arquivo (CSV ou .xlsx)">
                    <el-upload action="" :auto-upload="false" :limit="1" :on-change="onFileChange" :on-remove="onFileRemove" accept=".csv,.xlsx,.xls">
                        <el-button icon="el-icon-upload2">Selecionar planilha</el-button>
                    </el-upload>
                </el-form-item>

                <el-row>
                    <el-col :xs="24" class="u-text-right">
                        <el-button type="primary" icon="el-icon-check" :disabled="!tabela || !file" @click="importar">IMPORTAR</el-button>
                    </el-col>
                </el-row>
            </el-form>

            <el-alert v-if="resultado" type="success" :closable="false" show-icon class="u-mt-15"
                :title="`Importação concluída: ${resultado.inseridos} inseridos, ${resultado.atualizados} atualizados, ${resultado.ignorados} ignorados.`">
            </el-alert>
        </c-panel>
    </div>
</template>

<script>
export default {
    data () {
        return {
            tabelas: [],
            tabela: null,
            file: null,
            resultado: null
        }
    },
    computed: {
        tabelaSel () { return this.tabelas.find(t => t.tabela === this.tabela) || null }
    },
    mounted () { this.carregarTabelas() },
    methods: {
        baseUrl () { return this.$store.state.config.baseUrlApi },
        carregarTabelas () {
            this.$axios.get(`${this.baseUrl()}/api/importacao-auxiliar-educacenso/tabelas`, this.$store.getters.getHeaderAuth)
                .then(r => { this.tabelas = Array.isArray(r.data) ? r.data : [] })
                .catch(e => this.$store.commit('throwException', e))
        },
        onTabela () { this.resultado = null },
        onFileChange (f) { this.file = f.raw; this.resultado = null },
        onFileRemove () { this.file = null },
        importar () {
            if (!this.tabela || !this.file) { return }
            const formData = new FormData()
            formData.append('tabela', this.tabela)
            formData.append('file', this.file)
            window.eventBus.$emit('loading', true)
            this.$axios.post(
                `${this.baseUrl()}/api/importacao-auxiliar-educacenso/importar`,
                formData,
                { headers: { ...this.$store.getters.getHeaderAuth.headers, 'Content-Type': 'multipart/form-data' } }
            ).then(r => {
                window.eventBus.$emit('loading', false)
                if (r.data && r.data.erro) {
                    window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                    return
                }
                this.resultado = r.data
                window.eventBus.$emit('alert', { msg: 'Importação concluída.', type: 'success' })
            }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
        }
    }
}
</script>
